"use client";

import { Select, SelectItem, Skeleton } from "@kyan/ui";

import { useUserTokensList } from "#/hooks/useUserTokensList";
import { BungeeToken } from "#/services/bridge/bridge.types";

import { ChainToken } from "./components/ChainToken";

interface TokenSelectorProps {
  onChange: (value: BungeeToken) => void;
  token: BungeeToken;
}

export const TokenSelector: React.FC<TokenSelectorProps> = ({
  onChange,
  token,
}) => {
  const { data: userTokens, isLoading } = useUserTokensList();

  const handleValueChange = (value: string) => {
    const [chainId, address] = value.split("-");

    const selected = userTokens.find(
      (t) => t.chainId.toString() === chainId && t.address === address,
    );
    if (selected) onChange({ ...selected });
  };

  return (
    <Select
      iconClassName="ml-auto"
      contentClassName="max-h-80"
      value={`${token.chainId}-${token.address}`}
      valueComponent={<ChainToken token={token} className="w-full" />}
      triggerClassName="w-full bg-white border-divider dark:bg-buttonBg"
      onValueChange={handleValueChange}
    >
      {userTokens.map((tokenItem) => {
        const value = `${tokenItem.chainId}-${tokenItem.address}`;
        return (
          <SelectItem
            key={value}
            value={value}
            itemComponent={<ChainToken token={tokenItem} className="w-full" />}
          />
        );
      })}
      {isLoading && (
        <div className="flex w-full flex-col items-center gap-2 p-3">
          <Skeleton className="w-full" />
          <Skeleton className="w-full" />
          <Skeleton className="w-full" />
        </div>
      )}
    </Select>
  );
};
